<template>
    <div class="wrapper ">
        Monitoring !
    </div>
</template>

<script>
    export default {
        name: "Monitoring"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Monitoring.vue